@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.root {
    background-image:
        url("../../../static/img/silhouette-lobster.png"),
        url("../../../static/img/silhouette-crab.png");
    background-repeat: no-repeat;
    background-position:
        top left,
        bottom right;
    background-size: 17%, 12%;
    padding: 2.5rem 0;
    text-align: center;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        background-position:
            -25% -50%,
            125% center;
        background-size: 50%, 40%;
    }
}

.title {
    color: var(--color-lobster);
    line-height: 0.78;
    margin-bottom: 1.5rem;
    text-transform: uppercase;
}

.fresh {
    display: block;
    font-size: 6.875rem;
}

.catch {
    display: block;
    font-size: 5.9375rem;
}

.news {
    display: block;
    font-size: 7.375rem;
}

.subtitle {
    color: var(--color-lobster);
    font-size: 2.5rem;
    line-height: 1.1;
    margin: 1.375rem 0;
}

.divider {
    align-items: center;
    display: flex;
    gap: 0.5rem;
    margin: 0 auto;
    width: 50%;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 80%;
    }

    &::before,
    &::after {
        background-image: url("../../../static/img/rope.svg");
        background-position-x: 0;
        background-position-y: 50%;
        background-repeat: repeat-x;
        background-size: 31px 40px;
        content: "";
        display: block;
        flex: 1;
        height: 31px;
    }

    & svg {
        fill: var(--color-lobster);
    }
}

.button {
    composes: roundButton from "../../styles/buttons.module.scss";
}
